import type { CSSProperties } from "react";
import type { Platform } from "../domain/types";

export function PlatformBadge({
  platform,
  compact = false,
}: {
  platform: Platform;
  compact?: boolean;
}) {
  return (
    <span
      className={`platform-badge ${compact ? "platform-badge--compact" : ""}`}
      style={{ "--platform-color": platform.colorStrong } as CSSProperties}
    >
      <span aria-hidden="true" className="platform-badge__mark">
        {platform.name.slice(0, 1)}
      </span>
      {platform.name}
    </span>
  );
}
